import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	dialogTwo: 3,
	showKeyboard: 4,
	monitorOne: 5,
	monitorTwo: 6,
	monitorThree: 7,
	monitorFour: 8,
	dialogThree: 9,
	monitorFive: 10,
	monitorSix: 11,
	monitorSeven: 12,
	monitorEight: 13,
	monitorNine: 14,
	monitorTen: 15,
	dialogFour: 16,
	win: 17,
}

export const Tema5SubtopicOneActivityOne = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema5.activities.subtema1], 1);
	useEffect(() => {
		if (loaded) {
			console.log("tema 5 subtema1 activity 1");
			ObserverEmitter.emit(EVENTS.tema5.subtopicOne.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.initScene, 1);
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's1_m1')
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, 0.139, 2.38)
						ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, true)
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 1: Corresponsalías." />
					<DialogBarNew
						dialog={
							'Nuestro primer tema será "Corresponsalías".'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							setUiToShow(steps.viewActivities);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1: Corresponsalías"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<DialogBarNew
						dialog={
							"El Servicio de Corresponsalías ayuda al Cliente a pagar sus tarjetas en nuestras Tiendas."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.characterAnimations.idle);
							ObserverEmitter.emit(EVENTS.tema4.subtopicFour.activityFive.moveCameraOverKeyboard)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.animateKey, 'S')
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a03)
							setUiToShow(steps.showKeyboard);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.showKeyboard && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={
							'Primer paso: Da clic encima de la opción "Financieros" en la pantalla, o presiona la tecla "S".'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a04)
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.clearKeyAnimation, 'S')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, 0.139, 2.38)
							setUiToShow(steps.monitorOne);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorOne && (
				<>
					<DialogBarNew
						dialog={
							'Segundo paso: De las opciones desplegadas, elige "Depósito".'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a05)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's1_m2')
							setUiToShow(steps.monitorTwo);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorTwo && (
				<>
					<DialogBarNew
						dialog={
							'Tercer paso: Da clic en la opción "Depósito de Tarjeta", seguido de esto, aparecerá un mensaje de espera.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a06)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's1_m3')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.14, 2.81)
							setUiToShow(steps.monitorThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorThree && (
				<>
					<DialogBarNew
						dialog={
							'Cuarto paso: Busca tu usuario de cajero y da clic en aceptar.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a07)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's1_m4')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.05, 2.92)
							setUiToShow(steps.monitorFour);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorFour && (
				<>
					<DialogBarNew
						dialog={
							'Quinto paso: Ingresa tu contraseña y da clic en "Aceptar".'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a08)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={
							'Nota: Tu contraseña es única, no debe ser compartida y es proporcionada por tu Líder de Tienda.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a09)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's1_m5')
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, false)
							setUiToShow(steps.monitorFive);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorFive && (
				<>
					<DialogBarNew
						dialog={
							'Sexto paso: Ingresa el número de tarjeta y confírmalo con el Cliente.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a10)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's1_m6')
							setUiToShow(steps.monitorSix);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorSix && (
				<>
					<DialogBarNew
						dialog={
							'Séptimo paso: Ingresa el monto a depositar y confírmalo con el Cliente, posteriormente presiona "Enter".'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a11)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's1_m7')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, true)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.188, 2.74)
							setUiToShow(steps.monitorSeven);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorSeven && (
				<>
					<DialogBarNew
						dialog={
							'Octavo paso: Aparecerá un letrero de confirmación, reafirma con el Cliente el monto y si es correcto, da clic en "Sí".'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a12)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's1_m8')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.16, 2.91)
							setUiToShow(steps.monitorEight);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorEight && (
				<>
					<DialogBarNew
						dialog={
							'Noveno paso: Subtotaliza y selecciona la cantidad en efectivo con la que se hará el cargo.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a13)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's1_m9')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.19, 2.97)
							setUiToShow(steps.monitorNine);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorNine && (
				<>
					<DialogBarNew
						dialog={
							'Décimo paso: Aparece la ventana con los datos proporcionados, haz clic en "Continuar".'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a14)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.changeImageMonitor, 's1_m10')
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenPosition, -11.566, -0.08, 2.74)
							setUiToShow(steps.monitorTen);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.monitorTen && (
				<>
					<DialogBarNew
						dialog={
							'A continuación, da clic en "Si" y en caso de que el Cliente lo necesite, reimprime el comprobante.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T5.sub01.sub1_act1_a15)
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
							ObserverEmitter.emit(EVENTS.tema5.subtopicOne.activityOne.buttonScreenVisibility, false)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={
							'Recuerda tener mucha precaución al momento de colocar los números de tarjeta y del monto, y procura siempre revisar con el Cliente que todo esté correcto.'
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="Has completado con éxito la sección sobre el Servicio de Corresponsalías."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 10,
									subtema: tasksId.tema5.activities.subtema1,
								})
							);
							navigation("/home5/tema5/subtema1/activityTwo");
						}}
					/>
				</>
			)}

		</>

	)
}